import React, { useRef, useEffect, useState } from "react";
import Layout from "./Layout";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Loader from "../Loader";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const Calculator = () => {
  const { t } = useTranslation();
  const [showCalc, setShowCalc] = useState(false);
  const calculator = useRef();
  const [calculatedAmounts, setCalculatedAmounts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [salaryAfterTax, setSalaryAfterTax] = useState(0);
  const [salaryTax, setSalaryTax] = useState(0);

  // const user = useSelector((state) => state.auth.user);
  const [amountValue, setAmountValue] = useState(0);
  const [amounts, setAmount] = useState(0);

  const globalData = useSelector((state) => state?.globalData?.data);
  let language = localStorage.getItem("i18nextLng");

  const { register, reset } = useForm();


  const handleAmountChange=(value)=>{
    if (value !== 0) {
      setAmount(value)
      setSalaryTax(0);
    }
    setAmountValue(value);
    setSalaryAfterTax(0);
  }
  
  const handleSalaryChange=(value)=>{
    if (value !== 0) {
      setSalaryTax(value);
      setAmount(0);
    }
    setSalaryAfterTax(value);
    setAmountValue(0);
  }

  const handleChange = async () => {
    try {
      if (Number(amounts) !== 0 || Number(salaryTax) !== 0) {
        setLoading(true);
        const res = await axios.post("invoice/invoicecalculations", {
          amount: amounts ? amounts : 0,
          salaryAfterTax: salaryTax ? salaryTax : 0,
          ForpAmount: 0,
          vat: 25,
          tax: parseFloat(globalData.tax.globalValue),
          fee: parseFloat(globalData.fee.globalValue),
          socialFee: parseFloat(globalData.socialFee.globalValue),
          allowance: 0,
          travel: 0,
          expressPayout: false,
        });
        if (res.data.statusCode === 200 && res.data.response.amount !== 0) {
          setShowCalc(true);
        } else if (res.data.response.amount === 0) {
          setShowCalc(false);
        }
        setCalculatedAmounts(res.data.response);
        reset({
          amountInputValue: Number(
            res.data.response.amount?.toFixed()
          ).toLocaleString(LOCALES.EN_US), 
          salaryInputValue: Number(
            res.data.response.net?.toFixed()
          ).toLocaleString(LOCALES.EN_US), 
        });
        setLoading(false);
      } else {
        setCalculatedAmounts();
        reset({
          amountInputValue: "",
          salaryInputValue: "",
        });
        setShowCalc(false);
      }
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout className="mt-5 invoice-space" showSidebar bgcolor>
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/calculator-anchor"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/kalkylator-ankare"
          />
        )}
      </Helmet>
      {loading && <Loader />}
      <div className="p-4 w-100 py-5 mr-0">
        <div className="w-75 m-auto">
          <div className="p-4 w-100 custom-shadow-box" ref={calculator}>
            <h6 className="mb-2 font-weight-bold text-light">
              {t("Calculator")}
            </h6>
            <div className="w-100 p-4 calculator-div">
              <div className="form-group">
                <label
                  className="text-primary font-weight-bold"
                  htmlFor="amountToInvoice"
                >
                  {t("AMOUNT TO INVOICE")}
                </label>

                <input
                  className="form-control form-control-lg mt-0 bg-light"
                  id="amountToInvoice"
                  min="0"
                  placeholder={t("Enter your invoicing amount here.")}
                  onKeyDown={(e) => {
                    // Allow only numbers, decimal point, and specific control keys
                    if (
                      !/[\d.]/.test(e.key) &&
                      ![
                        "Backspace",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                        "Delete",
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onFocus={(e) =>
                    e.target.addEventListener(
                      "wheel",
                      function (e) {
                        e.preventDefault();
                      },
                      { passive: false }
                    )
                  }
                  {...register("amountInputValue", {
                    onChange: (e) => {
                      handleAmountChange(e.target.value)
                    },
                  })}
                />
              </div>

              <div className="form-group">
                <label
                  className="text-primary font-weight-bold"
                  htmlFor="salaryAfterTax"
                >
                  {t("SALARY AFTER TAX")}
                </label>
                <input
                  // type="number"
                  className="form-control form-control-lg mt-0 bg-light"
                  onKeyDown={(e) => {
                    // Allow only numbers, decimal point, and specific control keys
                    if (
                      !/[\d.]/.test(e.key) &&
                      ![
                        "Backspace",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                        "Delete",
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  id="salaryAfterTax"
                  placeholder={t(
                    "Or enter your salary after all taxes and fees."
                  )}
                  {...register("salaryInputValue", {
                    onChange: (e) => {
                      handleSalaryChange(e.target.value)
                    },
                  })}
                />
              </div>

              {calculatedAmounts && showCalc && (
                <div>
                  <div className="d-flex calculator_dash">
                    <p className="m-0">{t("Invoice amount inc. VAT")}</p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.amountIncludingVat?.toFixed()}
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="mb-0">{t("VAT")}</p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.vat?.toFixed()}
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="mb-0">{t("Invoice amount ex. VAT")}</p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.amount?.toFixed()}
                    </p>
                  </div>
                  <div className="d-flex bg-highlight">
                    <p>
                      <b>*</b>
                      {t("Invozio Fee")}
                    </p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.fee?.toFixed()}
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="mb-0">
                      <b>*</b>
                      {t("Social Fees")}{" "}
                      {calculatedAmounts?.socialFeeRateDeduction}%
                    </p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.socialFee?.toFixed()}
                    </p>
                  </div>

                  <div className="d-flex">
                    <p className="mb-0">
                      {t("Gross salary incl. holiday pay")}
                    </p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.gross?.toFixed()}
                    </p>
                  </div>
                  <div className="d-flex">
                    <p className="mb-0">
                      {t("Income Tax")} {calculatedAmounts?.taxRateDeduction}%{" "}
                    </p>
                    <p className="m-0 ml-auto">
                      SEK {calculatedAmounts.tax?.toFixed()}
                    </p>
                  </div>

                  <div className="d-flex">
                    <p className="mb-0 text-primary font-weight-bold">
                      {t("Net salary incl. holiday pay")}
                    </p>
                    <p className="m-0 ml-auto text-primary font-weight-bold">
                      SEK {calculatedAmounts.net?.toFixed()}
                    </p>
                  </div>

                  <div className="loan-group">
                    <p style={{ color: "rgb(164 117 117)" }}>
                      *
                      {t(
                        "If you are 66 years or older, our platform automatically calculates your social security contributions at 10.21%"
                      )}
                    </p>
                  </div>
                  <Button
                    className="mb-2 p-0 mt-2"
                    onClick={() => setShowCalc(false)}
                    variant="link"
                    size="sm"
                    style={{ color: "#372776" }}
                  >
                    {t("Hide how we calculated")} -
                  </Button>
                </div>
              )}

              {calculatedAmounts && !showCalc && !(amounts === 0) && (
                <Button
                  className="mb-2 p-0"
                  onClick={() => setShowCalc(true)}
                  variant="link"
                  size="sm"
                >
                  {t("See how we calculated")} +
                </Button>
              )}

              <div className="text-center mb-3">
                <Button
                  className="mr-3 mt-4 bottom_create_btn"
                  onClick={handleChange}
                >
                  {t("Calculate")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Calculator;
